// Modules
import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostBinding,
  HostListener,
  OnChanges,
} from '@angular/core';

@Directive({
    selector: '[drag-and-drop]',
    standalone: false
})
export class FileDragDropDirective implements OnChanges {
  // Inputs
  @Input() disabled: boolean = false;
  @Input() hasError: boolean = false;

  // Outputs
  @Output() onFileDropped = new EventEmitter();

  // Host bindings
  @HostBinding('class') elementClass = 'upload-file-container';
  @HostBinding('style.background-color') background = '#f1eefa';

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();

    this.background = '#c5bdec';
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    this.background = '#f1eefa';
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(event) {
    event.preventDefault();
    event.stopPropagation();

    this.background = '#f1eefa';

    if (!this.disabled) {
      const files: any[] = event.dataTransfer.files;
      if (files.length > 0) this.onFileDropped.emit(files);
    }
  }

  // Constructor
  constructor() {}

  // On directive changes
  ngOnChanges() {
    if (this.hasError) {
      this.elementClass = 'upload-file-container error';
    } else {
      this.elementClass = 'upload-file-container';
    }
  }
}
